/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetPaymentRequestEvidence200ResponseErrors
 */
export interface GetPaymentRequestEvidence200ResponseErrors {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseErrors
     */
    'detectedDpi'?: GetPaymentRequestEvidence200ResponseErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseErrors
     */
    'calculatedDpi'?: GetPaymentRequestEvidence200ResponseErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseErrors
     */
    'colorGradation'?: GetPaymentRequestEvidence200ResponseErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseErrors
     */
    'heightMillis'?: GetPaymentRequestEvidence200ResponseErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseErrors
     */
    'widthMillis'?: GetPaymentRequestEvidence200ResponseErrorsWidthMillisEnum;
}

export const GetPaymentRequestEvidence200ResponseErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidence200ResponseErrorsDetectedDpiEnum = typeof GetPaymentRequestEvidence200ResponseErrorsDetectedDpiEnum[keyof typeof GetPaymentRequestEvidence200ResponseErrorsDetectedDpiEnum];
export const GetPaymentRequestEvidence200ResponseErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidence200ResponseErrorsCalculatedDpiEnum = typeof GetPaymentRequestEvidence200ResponseErrorsCalculatedDpiEnum[keyof typeof GetPaymentRequestEvidence200ResponseErrorsCalculatedDpiEnum];
export const GetPaymentRequestEvidence200ResponseErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestEvidence200ResponseErrorsColorGradationEnum = typeof GetPaymentRequestEvidence200ResponseErrorsColorGradationEnum[keyof typeof GetPaymentRequestEvidence200ResponseErrorsColorGradationEnum];
export const GetPaymentRequestEvidence200ResponseErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidence200ResponseErrorsHeightMillisEnum = typeof GetPaymentRequestEvidence200ResponseErrorsHeightMillisEnum[keyof typeof GetPaymentRequestEvidence200ResponseErrorsHeightMillisEnum];
export const GetPaymentRequestEvidence200ResponseErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidence200ResponseErrorsWidthMillisEnum = typeof GetPaymentRequestEvidence200ResponseErrorsWidthMillisEnum[keyof typeof GetPaymentRequestEvidence200ResponseErrorsWidthMillisEnum];


